// GENERATED from loot.store by tools/loot-store.js — do not edit.
// Edit the store (or the knobs app Loot tab), then re-run the generator
// (`node tools/loot-store.js`). The store is the single source of
// truth; this module is its projection shared/src/loot.ts imports
// (the sim's death roll, the sack, the cross-store references).
export const LOOT_DATA = [
  {
    "id": 0,
    "name": "Easy Enemy",
    "itemsMin": 1,
    "itemsMax": 3,
    "dropsBones": true,
    "items": [
      { "itemClass": "consumable", "kind": 0, "probability": 30, "qMin": 1, "qMax": 3 },
      { "itemClass": "consumable", "kind": 1, "probability": 2, "qMin": 1, "qMax": 1 },
      { "itemClass": "consumable", "kind": 5, "probability": 2, "qMin": 1, "qMax": 1 },
      { "itemClass": "consumable", "kind": 7, "probability": 2, "qMin": 1, "qMax": 1 },
      { "itemClass": "consumable", "kind": 2, "probability": 15, "qMin": 1, "qMax": 2 },
      { "itemClass": "consumable", "kind": 3, "probability": 5, "qMin": 1, "qMax": 1 },
    ],
  },
  {
    "id": 1,
    "name": "Hard Enemy",
    "itemsMin": 1,
    "itemsMax": 3,
    "dropsBones": true,
    "items": [
      { "itemClass": "consumable", "kind": 0, "probability": 20, "qMin": 1, "qMax": 5 },
      { "itemClass": "consumable", "kind": 4, "probability": 5, "qMin": 1, "qMax": 1 },
      { "itemClass": "consumable", "kind": 6, "probability": 2, "qMin": 1, "qMax": 1 },
      { "itemClass": "consumable", "kind": 3, "probability": 20, "qMin": 1, "qMax": 4 },
      { "itemClass": "consumable", "kind": 2, "probability": 15, "qMin": 1, "qMax": 3 },
    ],
  },
  {
    "id": 2,
    "name": "Luminak",
    "itemsMin": 1,
    "itemsMax": 1,
    "dropsBones": true,
    "items": [
      { "itemClass": "equipment", "kind": 9, "probability": 25, "qMin": 1, "qMax": 1 },
      { "itemClass": "equipment", "kind": 10, "probability": 25, "qMin": 1, "qMax": 1 },
      { "itemClass": "equipment", "kind": 7, "probability": 25, "qMin": 1, "qMax": 1 },
      { "itemClass": "equipment", "kind": 4, "probability": 25, "qMin": 1, "qMax": 1 },
    ],
  },
  {
    "id": 3,
    "name": "Easy Sack",
    "itemsMin": 1,
    "itemsMax": 8,
    "dropsBones": true,
    "items": [
      { "itemClass": "consumable", "kind": 0, "probability": 20, "qMin": 1, "qMax": 10 },
      { "itemClass": "consumable", "kind": 1, "probability": 5, "qMin": 1, "qMax": 1 },
      { "itemClass": "consumable", "kind": 6, "probability": 5, "qMin": 1, "qMax": 1 },
      { "itemClass": "consumable", "kind": 5, "probability": 5, "qMin": 1, "qMax": 1 },
      { "itemClass": "consumable", "kind": 4, "probability": 5, "qMin": 1, "qMax": 1 },
      { "itemClass": "consumable", "kind": 7, "probability": 5, "qMin": 1, "qMax": 1 },
      { "itemClass": "consumable", "kind": 2, "probability": 10, "qMin": 1, "qMax": 5 },
      { "itemClass": "consumable", "kind": 3, "probability": 10, "qMin": 1, "qMax": 2 },
    ],
  },
] as const;
